import { borderRadius, Button } from '@toggle/design-system';
import styled from 'styled-components';

export const AddWatchlistButton = styled(Button)<{
  $isInWatchlist: boolean;
}>`
  ${props =>
    props.$isInWatchlist &&
    `
      background: var(--surface-success);
      ${borderRadius.rFull};

      & svg {
        fill: var(--icon-success);
      }

      &:hover {
        background: var(--surface-success);
      }
    `}
`;
